import React from 'react';
import { motion } from 'framer-motion';
import { Users, Truck, Building2, Headphones, UserCheck, AlertTriangle, FileText, DollarSign, GraduationCap, Wrench, Sparkles } from 'lucide-react';

const STAT_CONFIG = [
  { key: 'total_users', label: 'Total Users', icon: Users, color: 'from-blue-500 to-blue-600' },
  { key: 'drivers', label: 'Drivers', icon: Truck, color: 'from-cyan-500 to-cyan-600' },
  { key: 'carriers', label: 'Carriers', icon: Building2, color: 'from-emerald-500 to-emerald-600' },
  { key: 'dispatchers', label: 'Dispatchers', icon: Headphones, color: 'from-purple-500 to-purple-600' },
  { key: 'learners', label: 'Learners', icon: GraduationCap, color: 'from-orange-500 to-amber-600' },
  { key: 'service_providers', label: 'Service Providers', icon: Wrench, color: 'from-sky-500 to-blue-600' },
  { key: 'affiliates', label: 'Affiliates', icon: Sparkles, color: 'from-fuchsia-500 to-pink-600' },
  { key: 'verified', label: 'Verified', icon: UserCheck, color: 'from-green-500 to-green-600' },
  { key: 'pending', label: 'Pending', icon: AlertTriangle, color: 'from-yellow-500 to-yellow-600' },
  { key: 'total_jobs', label: 'Total Jobs', icon: FileText, color: 'from-orange-500 to-orange-600' },
  { key: 'total_referrals', label: 'Referrals', icon: DollarSign, color: 'from-pink-500 to-pink-600' },
];

export const StatsOverview = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {STAT_CONFIG.map((stat, i) => {
        const Icon = stat.icon;
        return (
          <motion.div
            key={stat.key}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            className="bg-white/5 border border-white/10 rounded-xl p-4"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-slate-400 text-xs font-medium uppercase tracking-wider">{stat.label}</span>
              <div className={`p-1.5 rounded-lg bg-gradient-to-br ${stat.color}`}>
                <Icon className="h-3.5 w-3.5 text-white" />
              </div>
            </div>
            <p className="text-2xl font-bold text-white">{stats[stat.key]}</p>
          </motion.div>
        );
      })}
    </div>
  );
};
